import { render } from "./Licensing.vue?vue&type=template&id=4025859e&scoped=true"
import script from "./Licensing.vue?vue&type=script&lang=js"
export * from "./Licensing.vue?vue&type=script&lang=js"

import "./Licensing.vue?vue&type=style&index=0&id=4025859e&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4025859e"]])

export default __exports__